import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, RetentionPreviewRequest, RetentionPreviewResponse } from '../types/showcase';

/** C027 데이터 보존 데모(강제 dryRun · read-only) — POST .../retention/preview (queue #646 §R646-2). */
export function useRetentionPreview() {
  return useMutation<RetentionPreviewResponse, ApiError, RetentionPreviewRequest>({
    mutationFn: (req) => showcaseApi.retentionPreview(req),
    mutationKey: ['common-showcase', 'retention', 'preview'],
  });
}
